import { Flame, Trophy, CalendarCheck } from "lucide-react";
import { brandStyle } from "@/lib/brand";

export const ThemePreviewCard = ({ brand, palette }) => {
  const style = brandStyle({ ...(brand || {}), palette });
  const name = brand?.studioName || "Your Studio";
  return (
    <div className="tc-preview" style={style} data-testid="theme-preview-card">
      <div className="pv-top" style={{ background: "var(--nav)" }}>
        <span className="pv-logo">{name.split(" ").map((w) => w[0]).join("").slice(0, 2).toUpperCase()}</span>
        <div><b>{name}</b><small>Client portal</small></div>
      </div>
      <div className="pv-tabs"><span className="on">Home</span><span>Progress</span><span>Plan</span><span>Chat</span></div>
      <div className="pv-body">
        <div className="pv-streak"><span className="pv-flame"><Flame size={18} fill="currentColor" /></span><div><small>Session streak</small><b>4 <em>wks</em></b></div><span className="pv-best"><Trophy size={11} /> Best 6</span></div>
        <div className="pv-card">
          <small><CalendarCheck size={11} /> Your next session</small>
          <b>Thu 07:00 · Lower body</b>
          <div className="pv-btns"><span className="pv-btn">Confirm</span><span className="pv-btn o">Change time</span></div>
        </div>
        <p className="pv-quote">“Show up. The rest follows.”</p>
      </div>
    </div>
  );
};
